export default __webpack_public_path__ + "static/media/title-vinho.fb910366.png";